import React from "react";
import styled from "styled-components";
import { Container, Search, Title } from "../../UI";

const Hero = props => {
  return (
    <div className={props.className}>
      <Container>
        {props.titleImg ? (
          <img src={props.titleImg} alt={props.title} />
        ) : (
          <Title>{props.title}</Title>
        )}
        {props.children &&
          props.description === "top" && (
            <div className="description">{props.children}</div>
          )}
        <Search theme="dark" placeholder={props.search} />
        {props.children &&
          props.description !== "top" && (
            <div className="description">{props.children}</div>
          )}
      </Container>
      {props.gradient && <Gradient />}
    </div>
  );
};

const Gradient = styled.div`
  height: 150px;
  background: linear-gradient(transparent, white);
  margin-left: -16px;
  margin-right: -16px;
  margin-bottom: -48px;
  margin-top: 48px;
`;

export default styled(Hero)`
  background-image: ${props =>
    props.instance === "CEJIL"
      ? "url(https://sidh.cejil.org/public/hero.jpg)"
      : props.instance === "Zorlakay"
        ? "url(https://zorlakay.uwazi.io/public/zorlakay-hero.jpg)"
        : props.instance === "tgeu"
          ? "url(/tgeu/tgeu-hero.png)"
          : props.instance === "aot"
            ? "url(/aot-hero.png)"
            : props.instance === "CLEEN"
              ? "url(/cleen-hero.png)"
              : ""};
  background-color: ${props =>
    props.instance === "tgeu"
      ? "#f5ac3a"
      : props.instance === "CLEEN"
        ? "#010066"
        : "#e9ecef"};
  background-position: center center;
  background-size: cover;
  text-align: center;
  color: white;
  text-shadow: 3px 3px 15px #444;
  padding: 48px 16px;

  h1,
  img {
    margin: 0 0 16px;
  }

  img {
    max-width: 90%;
  }

  .description {
    font-size: 14px;
    margin: 10px 0;

    @media (min-width: 960px) {
      font-size: 18px;
    }

    a {
      background-color: rgba(255, 255, 255, 0.8);
      color: rgb(0, 0, 0) !important;
      padding: 3px 6px;
      border-radius: 3px;
      text-decoration: none;
      border: 0px none;
      text-shadow: white 0px 0px 5px;
    }
    a:hover {
      background-color: rgba(255, 255, 255, 1);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/UI/Hero/Hero.js